import { Tween, Easing } from '@tweenjs/tween.js';
import { formatCurrencyValue, getCurrencySymbol } from '../helper/currencies';
import { TweenBonusRound } from './Tweens';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { isDesktop } from 'react-device-detect';
import BonusTrigger from './BonusTrigger';
import { logger } from '@orbital/slot-lib';
const events = [
	EVENTS.SERVER_MSG,
	EVENTS.BET_PLACED,
	EVENTS.BONUS_BUY,
	EVENTS.MAIN_LINE_FINISHED,
	EVENTS.ALL_LINES_FINISHED,
	EVENTS.REEL_FINISHED,
	EVENTS.WIN_HIGHLIGHT,
	EVENTS.IS_DISABLED,
	EVENTS.SETTINGS_UPDATE
];
class BonusGameController {
	constructor(vc, conf) {
		this.config = conf;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.win = 0;
		this.prevWin = 0;
		this.previousTotal = 0;
		this.totalProgress = 0;
		this.counter = 0;
		this.pending = false;
		this.reels = GameConfigs.reelComponent;
		this.finish = true;
		this.isSpaceKeyDown = false;
		this.disable = false;
		this.trigger = new BonusTrigger();
		this.shotrcut = GameConfigs.settings.keyboard_shortcuts;

		if (vc) {
			this.vc = vc;
			this.items = this.vc.BonusItems.bonus_item_holder;

			this.character =
				this.vc.BonusItems.bonus_item_holder.bonus_character.character;
			this.character_blur =
				this.vc.BonusItems.bonus_item_holder.bonus_character.character_blur;

			this.vc.btn = this.vc.getChildByName('bonus_btn', true);
			this.vc.fg = this.vc.getChildByName('bonus_fg', true);
			if (isDesktop) {
				this.vc.fg_wow = this.vc.getChildByName('bonus_fg_wow', true);
				this.vc.fg_wow.alpha = 0;
				this.vc.fg_wow.gotoAndStop(0);
				this.vc.fg_wow.anchor.set(0.5, 0.5);
			}
			// if (!window.isMobile && !window.isTablet) {
			//   this.vc.fg_wow.alpha = 0;
			//   this.vc.fg_wow.gotoAndStop(0);
			//   this.vc.fg_wow.anchor.set(0.5, 0.5);
			// } else {
			//   this.vc.fg_wow.visible = false;
			// }
			this.vc.fg.anchor.set(0.5, 0.5);
			this.vc.fg.alpha = 1;
			this.tweenAnimations = new TweenBonusRound(
				this.character,
				this.character_blur,
				this.vc
			);
			this.bonusItems = [
				{
					x: 75,
					y: -100,
					item: this.items.bonus_item_1.bonus_item_special
				},
				{
					x: 245,
					y: -80,
					item: this.items.bonus_item_2.bonus_item_special
				},
				{
					x: 465,
					y: -95,
					item: this.items.bonus_item_3.bonus_item_special
				},
				{
					x: 645,
					y: -80,
					item: this.items.bonus_item_4.bonus_item_special
				},
				{
					x: 815,
					y: -85,
					item: this.items.bonus_item_5.bonus_item_special
				},
				{
					x: 1030,
					y: -95,
					item: this.items.bonus_item_6.bonus_item_special
				}
			];

			this.character.alpha = 0;
			this.character_blur.alpha = 0;
			this.character.scale.set(isDesktop ? 0.8 : 1.6);
			this.character_blur.scale.set(isDesktop ? 0.8 : 1.6);
			this.character_blur.anchor.set(0.5, 0.5);
			this.float();
			this.vc.win_bg_wrapper.alpha = 1;
			this.init();
			this.bonus_amount =
				this.vc.BonusItems.bonus_item_holder.bonus_item_3.text_wrapper.text;
			this.bonus_mult =
				this.vc.BonusItems.bonus_item_holder.bonus_item_6.text_wrapper.text;
			this.bonus_amount.text =
				'+' + GameConfigs.config.bonus_progress_half_spins;
			this.bonus_mult.text = GameConfigs.config.bonus_progress_end_mult + 'X';

			if (GameConfigs.config.bonus_progress_half_spins > 9) {
				this.bonus_amount.position.x = 35;
			} else {
				// this.bonus_amount.position.x = 50;
				this.bonus_amount.position.x = 90;
			}
			if (GameConfigs.config.bonus_progress_end_mult > 9) {
				this.bonus_mult.position.x = 68;
			} else {
				this.bonus_mult.position.x = 48;
			}

			if (GameConfigs.config.hasbonus) {
				if (GameConfigs.bonusRestore.bonusround) {
					this.setWin(GameConfigs.bonusRestore.bonusround.totalWin);
				} else {
					this.setWin(GameConfigs.bonusRestore.spinresult.totalWin);
				}
			} else {
				if (GameConfigs.bonusRoundInfo) {
					this.setWin(GameConfigs.bonusRoundInfo.win);
				}
			}
			this.vc.btn.handler = this.handler.bind(this);
			if (GameConfigs.bonusRestore) {
				if (
					GameConfigs.bonusRestore.bonusround &&
					GameConfigs.bonusRestore.bonusround.progress > this.totalProgress
				) {
					this.updateProgress(
						GameConfigs.bonusRestore.bonusround.progress - this.totalProgress
					);
				}
			}
			for (let i = 0; i < events.length; i++) {
				window.addEventListener(events[i], this, false);
			}
			if (
				GameConfigs.settings.keyboard_shortcuts &&
				!window.isMobile &&
				!window.isTablet
			) {
				setTimeout(() => {
					window.addEventListener('keydown', this, false);
					window.addEventListener('keyup', this, false);
					this.enabled = false;
				}, 500);
			} else {
				this.shotrcut = false;
			}
			GameConfigs.reelComponent.parent.sortableChildren = true;
			this.trigger.zIndex = 100000;
			GameConfigs.reelComponent.parent.addChildAt(this.trigger, 0);
			// this.updateProgress(6)
		} else {
			throw new Error('BonusGameController ' + JSON.stringify(this.config));
		}
	}

	showWow() {
		// window.sm.play({ name: "wow_voice_effect" });
		this.vc.fg.alpha = 0;
		this.vc.fg_wow.alpha = 1;
		this.vc.fg.gotoAndStop(0);
		this.vc.fg_wow.gotoAndPlay(0);
		this.vc.fg_wow.onComplete = () => {
			this.fade();
		};
	}

	fade() {
		this.vc.fg_wow.alpha = 0;
		this.vc.fg.alpha = 1;
		this.vc.fg_wow.gotoAndStop(0);
		this.vc.fg.gotoAndPlay(0);
	}

	float() {
		this.tween_1 = new Tween(this.items.bonus_item_1.bonus_item_progress)
			.to({ y: this.items.bonus_item_1.bonus_item_progress.y + 3 }, 1500)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.start();
		this.tween_2 = new Tween(this.items.bonus_item_2.bonus_item_progress)
			.to({ y: this.items.bonus_item_2.bonus_item_progress.y + 4 }, 1600)
			.delay(50)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.start();
		this.tween_3 = new Tween(this.items.bonus_item_3.bonus_item_progress)
			.to({ y: this.items.bonus_item_3.bonus_item_progress.y + 4 }, 1300)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.start();
		this.tween_4 = new Tween(this.items.bonus_item_4.bonus_item_progress)
			.to({ y: this.items.bonus_item_4.bonus_item_progress.y + 5 }, 1800)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.delay(40)
			.start();
		this.tween_5 = new Tween(this.items.bonus_item_5.bonus_item_progress)
			.to({ y: this.items.bonus_item_5.bonus_item_progress.y + 2 }, 1400)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.delay(50)
			.start();
		this.tween_5 = new Tween(this.items.bonus_item_5.bonus_item_progress)
			.to({ y: this.items.bonus_item_5.bonus_item_progress.y + 3 }, 1700)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.delay(10)
			.start();
		this.tween_6 = new Tween(this.items.bonus_item_6.bonus_item_progress)
			.to({ y: this.items.bonus_item_6.bonus_item_progress.y + 4 }, 1500)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.delay(50)
			.start();
	}

	handler() {
		if (!GameConfigs.canStopReel) return;
		if (GameConfigs.modal === 'win') return;
		if (this.disable) {
			return;
		}
		if (this.reels.rotating) {
			this.reels.fastStop();
		} else {
			if (this.placed) return;
			if (
				GameConfigs.bonusRoundData.totalbonusspins -
					GameConfigs.bonusRoundData.playedbonusspins >
				0
			) {
				this.bonusNextStep();
			}
		}
	}

	resize(w, h) {
		if (window.isMobile || window.isTablet) {
			if (w < h) {
				this.vc.btn.position.x = 126;
			} else {
				this.vc.btn.position.x = 40;
			}
		} else {
			this.vc.btn.position.x = 45;
		}
	}

	setWin(win) {
		this.vc.win_bg_wrapper.win_value.text = formatCurrencyValue(
			win,
			this.currency
		);
	}

	handleEvent(object) {
		switch (object.type) {
			case EVENTS.SERVER_MSG:
				this.serverMSG(object);
				break;
			case EVENTS.SETTINGS_UPDATE:
				this.settingsUdate(object);
				break;
			case 'keydown':
				if (object.keyCode === 32) {
					if (!this.shotrcut) {
						this.isSpaceKeyDown = false;
						return;
					}
					if (!this.isSpaceKeyDown) {
						this.isSpaceKeyDown = true;
						if (this.disable) return;
						this.vc.btn.mouseDownHandler();
						this.handler();
					}
				}
				break;
			case 'keyup':
				if (!this.shotrcut) {
					this.isSpaceKeyDown = false;
					return;
				}
				if (object.keyCode === 32) {
					if (this.isSpaceKeyDown) {
						this.isSpaceKeyDown = false;
						!this.disable && this.vc.btn.mouseUpHandler();
					}
				}
				break;
			case EVENTS.BET_PLACED:
				this.betPlaced(object);
				break;
			case EVENTS.REEL_FINISHED:
				if (GameConfigs.bonusRoundData) {
					if (GameConfigs.bonusRoundData.progress > this.totalProgress) {
						this.updateProgress(
							GameConfigs.bonusRoundData.progress - this.totalProgress
						);
					}
				}
				break;
			case EVENTS.MAIN_LINE_FINISHED:
				if (GameConfigs.bonusRoundData.win > 0) {
					this.updateWin(GameConfigs.bonusRoundData.totalWin, false);
				}
				break;

			case EVENTS.ALL_LINES_FINISHED:
				if (!this.pending) {
					this.linesFinished();
				}
				break;
			case EVENTS.BONUS_BUY:
				if (!object.detail.bonus) {
					this.removeEventListeners();
				}
				break;
			case EVENTS.WIN_HIGHLIGHT:
				if (object.detail.open) {
					if (
						!window.isMobile &&
						!window.isTablet &&
						GameConfigs.settings.game_animation
					) {
						this.showWow();
					}
					this.pending = true;
				} else {
					if (this.pending) {
						this.linesFinished();
						this.pending = false;
					}

					this.updateWin(GameConfigs.bonusRoundData.totalWin, true);
				}
				break;
			default:
				break;
		}
	}

	settingsUdate(e) {
		if (e.detail.data.keyboard_shortcuts === undefined || !isDesktop) return;
		if (e.detail.data.keyboard_shortcuts) {
			if (!this.shotrcut) {
				window.addEventListener('keydown', this, false);
				window.addEventListener('keyup', this, false);
				this.shotrcut = true;
			}
		} else {
			if (this.shotrcut) {
				window.removeEventListener('keydown', this, false);
				window.removeEventListener('keyup', this, false);
			}
			this.shotrcut = false;
		}
	}

	serverMSG(e) {
		if (e.detail.service === 'bonusstep') {
			GameConfigs.bonusRoundData = e.detail.data;
		}
	}

	bonusNextStep() {
		if (
			GameConfigs.bonusRoundData.totalbonusspins -
				GameConfigs.bonusRoundData.playedbonusspins >
			0
		) {
			if (GameConfigs.bonusRoundData.retriggeredbonusspins > 0) {
				if (!this.trigger.animated) {
					logger.log(
						'animate trigger',
						GameConfigs.bonusRoundData,
						this.trigger
					);
					this.trigger.animate(
						GameConfigs.bonusRoundData.retriggeredbonusspins
					);
				}
			}
			if (GameConfigs.bonusRoundData.progress > this.totalProgress) {
				//progress updated from previous bonus
				clearTimeout(this.timeOut);
				this.timeOut = setTimeout(() => {
					this.sendBet();
				}, 2000);
			} else {
				clearTimeout(this.timeOut);
				this.timeOut = setTimeout(() => {
					this.sendBet();
				}, 0);
			}
		} else {
			this.finishBonus();
		}
	}

	betPlaced(e) {
		this.reels = GameConfigs.reelComponent;
		this.placed = e.detail.placed;
	}

	linesFinished() {
		if (this.placed) {
			return;
		}
		if (
			GameConfigs.bonusRoundData.totalbonusspins -
				GameConfigs.bonusRoundData.playedbonusspins >
			0
		) {
			this.bonusNextStep();
		} else {
			this.finishBonus();
		}
	}
	finishBonus() {
		if (this.finish) {
			this.finish = false;
			GameConfigs.bonusRoundActivated = 'finished';
			HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, {
				state: 'finished'
			});
			this.removeEventListeners();
		}
	}

	sendBet() {
		this.reels.start();
		window.connectionProvider.bonusRoundStep(
			JSON.stringify({
				service: 'bonusstep',
				data: {}
			})
		);
	}

	animateCharacter() {
		this.tweenAnimations.animateCharacterTween();
	}
	moveCharacter(x, y, item) {
		this.tweenAnimations.moveCharacterTween(x, y, item);
	}

	animateItems(item) {
		if (GameConfigs.settings.game_animation) {
			this.tweenAnimations.animateItemsTween(item);
		} else {
			item.alpha = 0;
			item.scale.set(0);
		}
	}

	loopItems() {
		setTimeout(() => {
			this.loop = setInterval(() => {
				if (this.counter >= this.totalProgress) {
					clearInterval(this.loop);
				} else {
					this.moveCharacter(
						this.bonusItems[this.counter].x,
						this.bonusItems[this.counter].y,
						this.bonusItems[this.counter].item
					);
					this.animateItems(this.bonusItems[this.counter].item);
					this.counter++;
				}
			}, 500);
		}, 500);
	}

	updateProgress(progress) {
		this.totalProgress += progress;
		if (this.previousTotal === 0) {
			this.animateCharacter();
			this.animateItems(this.bonusItems[0].item);
			this.previousTotal = this.totalProgress;
			this.counter = 1;
			if (progress > 1) {
				this.loopItems();
			}
		} else {
			this.loopItems();
		}
	}
	init() {
		if (GameConfigs.settings.game_animation) {
			this.reels.start();
			this.tweenAnimations.initBonusItemsTween(this.items);
		} else {
			this.items.bonus_item_1.y = -20;
			this.items.bonus_item_2.y = -50;
			this.items.bonus_item_3.y = -70;
			this.items.bonus_item_4.y = -20;
			this.items.bonus_item_5.y = -40;
			this.items.bonus_item_6.y = -60;

			this.vc.btn.x = 40;
			this.vc.btn.y = 0;
			this.vc.fg.scale.set(isDesktop ? 1 : 2);
			this.vc.win_bg_wrapper.win_bg.x = -10;
			this.vc.win_bg_wrapper.win_bg.y = -10;
			this.vc.win_bg_wrapper.alpha = 1;
			this.sendBet();
		}
	}

	updateWin(a, fast) {
		if (this.tweener) {
			this.tweener.stop();
		}

		let time = 1000;
		let winLevels = HELPERS.getWinLevels();
		if (winLevels.length > 0) {
			time = winLevels[winLevels.length - 1].time;
		}
		if (fast) {
			time = 500;
		}

		this.tweener = new Tween(this)
			.to({ win: a }, time)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setWin(this.win);
			})
			.onComplete(() => {
				this.tweener = null;
			})
			.start();
	}

	removeEventListeners() {
		this.vc.btn.handler = null;
		this.isSpaceKeyDown = false;
		for (let i = 0; i < events.length; i++) {
			window.removeEventListener(events[i], this, false);
		}
		window.removeEventListener('keydown', this, false);
		window.removeEventListener('keyup', this, false);
	}
}

export default BonusGameController;
